module.exports = __webpack_public_path__ + "img/c08_unitfiremonkey_Normal_ua.b019feb4.webp";